
import React, { useState, useRef, useEffect } from "react";
import "./PictureCombiner.scss";
import translations from '../../utils/language/translations.json'
import { useTranslation } from 'react-i18next';
 
const PictureCombiner = ({ cards }) => {
  const [imagesFromCards, setImagesFromCards] = useState([]); // Pre-existing images
  const [imagesFromSelector, setImagesFromSelector] = useState([]); // Manually uploaded images
  const [collageURLs, setCollageURLs] = useState([]); // Collage results
  const [numImages, setNumImages] = useState(8);
  const [showPrice, setShowPrice] = useState(true);
const [usePrice, setUsePrice] = useState(true);
  


  const [loading, setLoading] = useState(false); // Loading state for uploads
  const canvasRef = useRef(null);

  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.Export[key][currentLang];
  const [priceColor, setPriceColor] = useState("white");  // Default to white
  // Load existing card images when component mounts
  useEffect(() => {

    const processedImages = cards
      .map((card, index) => ({
        id: `existing-${index}`,
        dataURL: card.ImageFront||card.Image,
        price: card.Price || "N/A",
        EstimateValue:card.EstimateValue ||"N/A",
      }))
      .filter((image) => image.dataURL);
    setImagesFromCards(processedImages);
  }, [cards]);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoading(true); // Start loading animation

    const reader = new FileReader();
    reader.onload = (event) => {
      const newImage = {
        id: `uploaded-${Date.now()}`,
        dataURL: event.target.result,
        price: "",
      };

      setImagesFromSelector((prev) => [...prev, newImage]); // Only manual images in this state
      setLoading(false); // Stop loading animation
    };

    reader.readAsDataURL(file);
  };

  const handlePriceChange = (id, value) => {
    setImagesFromSelector((prev) =>
      prev.map((img) => (img.id === id ? { ...img, price: value,EstimateValue:value } : img))
    );
  };

  // useEffect(() => {
  //   generateCollages();
  // }, [cards, showPrice,priceOrEstimate, numImages, imagesFromSelector]);


  const generateCollages = async () => {
    setCollageURLs([]); // Reset collages
    const allImages = [...imagesFromCards, ...imagesFromSelector];
    console.log('allImages',allImages)
    // Validate images: Check if they load before using them
    const validImages = await Promise.all(
      allImages.map((image) =>
        new Promise((resolve) => {
          const img = new Image();
          img.crossOrigin = "anonymous";
          const isRemote = image.dataURL.startsWith("http");
          console.log('is remote',isRemote)
          const proxiedSrc = isRemote
          ? `${process.env.REACT_APP_API_BASE}/api/image-proxy?url=${encodeURIComponent(image.dataURL)}`
          : image.dataURL;
          img.src = proxiedSrc;
          console.log('proxiedSrc',proxiedSrc)
          img.onload = () => resolve({ ...image, proxiedSrc }); // ✅ keep this
          img.onerror = () => resolve(null);
        })
      )
    );
  
    const filteredImages = validImages.filter(Boolean); // Remove null/broken images
  
    if (filteredImages.length === 0) {
      console.warn('test live')
      console.warn("No valid images available for collage.");
      return; // Stop if no valid images exist
    }
  
    const totalCollages = Math.ceil(filteredImages.length / numImages);
    let newCollageURLs = [];
  
    for (let collageIndex = 0; collageIndex < totalCollages; collageIndex++) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
  
      const startIndex = collageIndex * numImages;
      const endIndex = Math.min(startIndex + numImages, filteredImages.length);
      const imagesForThisCollage = filteredImages.slice(startIndex, endIndex);
  
      const numCols = Math.ceil(Math.sqrt(imagesForThisCollage.length));
      const numRows = Math.ceil(imagesForThisCollage.length / numCols);
  
      canvas.width = numCols * 200;
      canvas.height = numRows * 250;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
  
      for (let i = 0; i < imagesForThisCollage.length; i++) {
        await new Promise((resolve) => {
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.src = imagesForThisCollage[i].proxiedSrc;
      
          img.onload = () => {
            const x = (i % numCols) * 200;
            const y = Math.floor(i / numCols) * 250;
            ctx.drawImage(img, x, y, 200, 250);
      
            ctx.font = "bold 20px Arial";
            ctx.fillStyle = "black";
            ctx.fillText((i + 1).toString(), x + 10, y + 30);
      
            if (showPrice) {
              ctx.fillStyle = priceColor;
              ctx.fillText(
                `$${usePrice
                  ? imagesForThisCollage[i].price || "N/A"
                  : imagesForThisCollage[i].EstimateValue || "N/A"}`,
                x + 120,
                y + 230
              );
            }
      
            resolve();
          };
      
          img.onerror = () => {
            console.warn(`Image failed to draw: ${img.src}`);
            resolve(); // Skip it
          };
        });
      }

  
      newCollageURLs.push(canvas.toDataURL());
    }
  
    setCollageURLs(newCollageURLs);
  };
  
useEffect(() => {
  if (!collageURLs.length) return; // only re-gen if something already exists
  const t = setTimeout(() => { generateCollages(); }, 220);
  return () => clearTimeout(t);
}, [showPrice, usePrice, priceColor, numImages]);

  // Remove a specific collage
  const removeCollage = (index) => {
    setCollageURLs((prevCollages) => prevCollages.filter((_, i) => i !== index));
  };

  const downloadImage = (url, index) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = `collage-${index + 1}.jpg`; // You can change the format if needed
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="picture-combiner">
      <h2>{t("Upload Photos & Generate Collage")}</h2>

<div className="form-group">
<select value={numImages} onChange={(e) => setNumImages(Number(e.target.value))} style={{width:'100%', marginBottom:'10px'}}>
          {[4, 6, 8, 16].map((option) => (
            <option key={option} value={option}>{option} {t("Images")}/page </option>
          ))}
        </select>

        <fieldset className="price-labels" aria-labelledby="price-labels-legend">
  <legend id="price-labels-legend">{"Option"}</legend>

  {/* Master switch */}
  <label className="toggle-row">
    <span>{t("Show Prices")}</span>
    <label className="toggle-switch">
      <input
        type="checkbox"
        checked={showPrice}
        onChange={(e) => setShowPrice(e.target.checked)}
        aria-label={t("Show Prices")}
      />
      <span className="slider"></span>
    </label>
  </label>

  {/* When prices are on, show options */}
  {showPrice && (
    <>
      {/* Segmented control: Estimate vs Price */}
      <div className="segmented" role="radiogroup" aria-label={"Label shows"}>
        <label className={`segment ${!usePrice ? "active" : ""}`}>
          <input
            type="radio"
            name="labelType"
            checked={!usePrice}
            onChange={() => setUsePrice(false)}
          />
          {t("Estimate Value")}
        </label>
        <label className={`segment ${usePrice ? "active" : ""}`}>
          <input
            type="radio"
            name="labelType"
            checked={usePrice}
            onChange={() => setUsePrice(true)}
          />
          {t("Price")}
        </label>
      </div>

      {/* Color choices as pills */}
      <div className="color-row" aria-label={t("Price Label Color")}>
        {["white","black","yellow","red","blue","green"].map((c) => (
          <button
            key={c}
            type="button"
            className={`color-pill ${priceColor === c ? "selected" : ""} ${c}`}
            onClick={() => setPriceColor(c)}
            aria-pressed={priceColor === c}
            aria-label={"Use color" + " " + c.charAt(0).toUpperCase()+c.slice(1)}
          />
        ))}
        {/* <span className="preview-chip" data-color={priceColor}>
          {usePrice ? t("Price") : t("Estimate Value")}
        </span> */}
      </div>
    </>
  )}
</fieldset>
<button className="btn-baseBlue"onClick={generateCollages}>{t("Generate Collages")}</button>
</div>
      {/* Collage Preview */}
      <div className="collage-preview">
      {collageURLs.map((url, index) => (
  <div key={index} className="collage-item">
    <div className="collage-buttons">
      <button className="delete-collage-btn" onClick={() => removeCollage(index)}>❌</button>
      <button className="download-collage-btn" onClick={() => downloadImage(url, index)}>⬇️</button>
      <button className="download-collage-btn" onClick={() => generateCollages()}>🔄</button>
      
    </div>
    <img src={url} alt={`Collage ${index + 1}`} />
  </div>
))}
      </div>

      <canvas ref={canvasRef} style={{ display: "none" }} />


      <div className="form-group">
       <label>{t("Upload Additional Images")}:</label>
        <input type="file" accept="image/*" onChange={handleImageUpload} />
        
      </div>

      {loading && (
        <div className="loading-indicator">
          {t("Uploading Image...")} <span className="spinner"></span>
        </div>
      )}

      {/* Editable Price Table for Newly Uploaded Images */}
      {imagesFromSelector.length > 0 && (
        <div className="editable-prices">
          <h3>{t("Edit Prices for Uploaded Images")}</h3>
          <table>
            <thead>
              <tr>
                <th>Image</th>
                <th>{t('Price')} ($)</th>
              </tr>
            </thead>
            <tbody>
              {imagesFromSelector.map((img) => (
                <tr key={img.id}>
                  <td>
                    <img className="card-thumbnail" src={img.dataURL} alt="Uploaded" />
                  </td>
                  <td>
                    <input
                      type="number"
                      className="price-input"
                      value={img.price || ""}
                      onChange={(e) => handlePriceChange(img.id, e.target.value)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>


        <button className="btn-baseBlue"onClick={generateCollages}>{t("Add to Collages")}</button>
        </div>

      )}
  



    </div>
  );
};

export default PictureCombiner;
